import { Injectable } from '@angular/core';
import { GenericService } from '../generic.service';
import { ScheduleCallResponse } from '../../models/schedule-peer-call/scheduleCallResponse';
import { ScheduleCallRequest } from '../../models/schedule-peer-call/scheduleCallRequest';
import { Observable } from 'rxjs';
import { apiResponse } from '../../models/apiResponse';
import { SetStudentPeerMeetingRequest } from '../../models/peer/setStudentPeerMeetingRequest';

@Injectable({
  providedIn: 'root'
})
export class SchedulePeerCallService {

  constructor(private genericService: GenericService) { }

  addScheduleCall(scheduleCallRequest: ScheduleCallRequest):Observable<ScheduleCallResponse>
  {
    return this.genericService.post(`schedulecall`, scheduleCallRequest);
  }
  getAllScheduledCallsForPeer(peerrevierId?: string): Observable<apiResponse<ScheduleCallResponse[]>>
  {
    return this.genericService.get(`schedulecalls/${peerrevierId}`);
  }
  getAllScheduledCallsForStudent(studentId: string): Observable<apiResponse<ScheduleCallResponse[]>>
  {
    return this.genericService.get(`schedulecall/${studentId}`)
  }
  setPeerStudentMeetingUrl(setStudentPeerMeetingRequest:SetStudentPeerMeetingRequest):Observable<ScheduleCallResponse>
  {
    return this.genericService.patch(`schedulecall`,setStudentPeerMeetingRequest);
  }
  deleteScheduledCall(id: string): Observable<ScheduleCallResponse>
  {
    return this.genericService.delete(`schedulecall/${id}`);
  }
}
